import { render, staticRenderFns } from "./user_play_status_changed.vue?vue&type=template&id=8b901c9e&scoped=true&"
import script from "./user_play_status_changed.vue?vue&type=script&lang=js&"
export * from "./user_play_status_changed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b901c9e",
  null
  
)

export default component.exports